const sumOf = (numbers): number => numbers.reduce((prevValue, value) => prevValue + value, 0);

export default sumOf;